export class UsageType {
    PORTAL: boolean;
    ADAPTOR?: boolean;
    WEBSERVIS: boolean;
    SAPPAKETI?: boolean;
    ADAPTORNAME?: string;
    constructor() {
        this.PORTAL = false;
        this.ADAPTOR = false;
        this.WEBSERVIS = false;
        this.SAPPAKETI = false;
        this.ADAPTORNAME = null;
    }
}
export class UsageTypes {
    public USAGETYPEFORMARCHIVE: UsageType;
    public USAGETYPEFORMDEFTER: UsageType;
    public USAGETYPEFORMDESPATCH: UsageType;
    public USAGETYPEFORMINVOICE: UsageType;
    public USAGETYPEFORMMM: UsageType;
    public USAGETYPEFORMMUTABAKAT: UsageType;
    public USAGETYPEFORMSMM: UsageType;

    constructor() {
        this.USAGETYPEFORMINVOICE = new UsageType();
        this.USAGETYPEFORMARCHIVE = new UsageType();
        this.USAGETYPEFORMDESPATCH = new UsageType();
        this.USAGETYPEFORMSMM = new UsageType();
        this.USAGETYPEFORMMM = new UsageType();
        this.USAGETYPEFORMDEFTER = new UsageType();
        this.USAGETYPEFORMMUTABAKAT = new UsageType();
    }
}